<ng-doc-smooth-resize [trigger]="code">
  <ng-doc-demo-displayer
    [code]="code"
    [border]="false"
    [expanded]="expanded"
    language="angular-html">
    <ng-container #demoOutlet></ng-container>
  </ng-doc-demo-displayer>
</ng-doc-smooth-resize>
